import { render, staticRenderFns } from "./LabelSettings.vue?vue&type=template&id=00d96247"
import script from "./LabelSettings.vue?vue&type=script&lang=js"
export * from "./LabelSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports